import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";

function UpdatePage() {
    const editor = useRef(null);
    const navigate = useNavigate();
    const { srno } = useParams();
    const url = process.env.REACT_APP_API_URL;

    const [pageid, setPageId] = useState("");
    const [pageurlname, setPageUrlName] = useState("");
    const [pagename, setPageName] = useState("");
    const [pagetitle, setPageTitle] = useState("");
    const [pagesubtitle, setPageSubtitle] = useState("");
    const [pagetype, setPageType] = useState("");
    const [pagesubtype, setPageSubtype] = useState("");
    const [pagecontent, setPageContent] = useState("");
    const [pagetheme, setPageTheme] = useState("");
    const [tobeaddedinmenu, setToBeAddedInMenu] = useState(0);
    const [tobeaddedinsubmenu1, setToBeAddedInSubmenu1] = useState(0);
    const [parentofsubmenu1, setParentofSubmenu1] = useState(-1);
    const [tobeaddedinsubmenu2, setToBeAddedInSubmenu2] = useState(0);
    const [parentofsubmenu2, setParentofSubmenu2] = useState(-1);
    const [iscommon, setIsCommon] = useState(0);
    const [issecure, setIsSecure] = useState(0);
    const [templateid, setTemplateId] = useState(1);
    const [hasmenubar, setHasMenubar] = useState(1);
    const [hasheader, setHasHeader] = useState(1);
    const [hasfooter, setHasFooter] = useState(1);
    const [hasleftsidebar, setHasLeftSidebar] = useState(0);
    const [hasrightsidebar, setHasRightSidebar] = useState(0);
    const [leftsidebarid, setLeftSidebarId] = useState(0);
    const [rightsidebarid, setRightSidebarId] = useState(0);
    const [isactive, setIsActive] = useState(1);

    const [showUpdateModal, setShowUpdateModal] = useState(false);

    const callApiPage = async () => {
        try {
            const headers = {
                'x-access-token': localStorage.getItem('jwttoken')
            };
            const response = await axios.get(url + "pages/showAll", { headers });
            const data = response.data.find(item => item.srno === parseInt(srno, 10));
             if (data) {
                setPageId(data.pageid || "");
                setPageUrlName(data.pageurlname || "");
                setPageName(data.pagename || "");
                setPageTitle(data.pagetitle || "");
                setPageSubtitle(data.pagesubtitle || "");
                setPageType(data.pagetype || "");
                setPageSubtype(data.pagesubtype || "");
                setPageContent(data.pagecontent || "");
                setPageTheme(data.pagetheme || "");
                setToBeAddedInMenu(data.tobeaddedinmenu || 0);
                setIsCommon(data.iscommon || 0);
                setIsSecure(data.issecure || 0);
                setTemplateId(data.templateid || 1);
                setHasMenubar(data.hasmenubar || 0);
                setHasHeader(data.hasheader || 0);
                setHasFooter(data.hasfooter || 0);
                setHasLeftSidebar(data.hasleftsidebar || 0);
                setHasRightSidebar(data.hasrightsidebar || 0);
                setLeftSidebarId(data.leftsidebarid || 0);
                setRightSidebarId(data.rightsidebarid || 0);
                setIsActive(data.isactive || 1);
            }
        } catch (error) {
            toast.error("Couldn't Fetch Page", {
                position: "top-right",
                autoClose: 1000,
                theme: "colored",
            });
        }
    };

    useEffect(() => {
        callApiPage();
    }, [srno]);

    const handleUpdate = async () => {
        setShowUpdateModal(false);
        const pageData = {
            pageid, pageurlname, pagename, pagetitle, pagesubtitle, pagetype,
            pagesubtype, pagecontent, pagetheme, 
            tobeaddedinmenu: Number(tobeaddedinmenu), 
            iscommon: Number(iscommon), 
            issecure: Number(issecure),
            templateid: Number(templateid), 
            hasmenubar: Number(hasmenubar), 
            hasheader: Number(hasheader), 
            hasfooter: Number(hasfooter), 
            hasleftsidebar: Number(hasleftsidebar),
            hasrightsidebar: Number(hasrightsidebar), 
            leftsidebarid: Number(leftsidebarid), 
            rightsidebarid: Number(rightsidebarid), 
            isactive: Number(isactive)
        };

        try {
            const headers = { 'x-access-token': localStorage.getItem('jwttoken') };
            await axios.put(`${url}pages/updates/${srno}`, pageData, { headers });
            
            toast.success("Page Updated Successfully", { theme: "colored" });
            setTimeout(() => navigate("/pages"), 2000);
        } catch (err) {
            toast.error("Update failed", { theme: "colored" });
        }
    };

    return (
       <div className="container mt-4 mb-5">
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />

            <Card className="form-card shadow-sm">
                <Card.Header className="form-card-header bg-primary text-white py-3">
                    <h5 className="mb-0">Update Page: {pagename || "Loading..."}</h5>
                </Card.Header>

                <Card.Body className="form-card-body p-4">
                    <Form onSubmit={(e) => { e.preventDefault(); setShowUpdateModal(true); }}>
                        
                        <h6 className="text-primary border-bottom pb-2 mb-3">Basic Information</h6>
                        <Row className="mb-3">
                            <Form.Group as={Col} md={4} controlId="pagename">
                                <Form.Label>Page Name:</Form.Label>
                                <Form.Control type="text" value={pagename} onChange={(e) => setPageName(e.target.value)} required />
                            </Form.Group>
                            <Form.Group as={Col} md={4} controlId="pageid">
                                <Form.Label>Page ID:</Form.Label>
                                <Form.Control type="text" value={pageid} onChange={(e) => setPageId(e.target.value)} required />
                            </Form.Group>
                            <Form.Group as={Col} md={4} controlId="pageurlname">
                                <Form.Label>URL Name:</Form.Label>
                                <Form.Control type="text" value={pageurlname} onChange={(e) => setPageUrlName(e.target.value)} required />
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} md={6} controlId="pagetitle">
                                <Form.Label>Page Title:</Form.Label>
                                <Form.Control type="text" value={pagetitle} onChange={(e) => setPageTitle(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={6} controlId="pagesubtitle">
                                <Form.Label>Page Sub-Title:</Form.Label>
                                <Form.Control type="text" value={pagesubtitle} onChange={(e) => setPageSubtitle(e.target.value)} />
                            </Form.Group>
                        </Row>

                        <Row className="mb-4">
                            <Form.Group as={Col} md={3} controlId="pagetype">
                                <Form.Label>Page Type:</Form.Label>
                                <Form.Control type="text" value={pagetype} onChange={(e) => setPageType(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={3} controlId="pagesubtype">
                                <Form.Label>Sub Type:</Form.Label>
                                <Form.Control type="text" value={pagesubtype} onChange={(e) => setPageSubtype(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={3} controlId="pagetheme">
                                <Form.Label>Theme:</Form.Label>
                                <Form.Control type="text" value={pagetheme} onChange={(e) => setPageTheme(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={3} controlId="templateid">
                                <Form.Label>Template ID:</Form.Label>
                                <Form.Control type="number" value={templateid} onChange={(e) => setTemplateId(e.target.value)} />
                            </Form.Group>
                        </Row>

                        <h6 className="text-primary border-bottom pb-2 mb-3 mt-4">Menu & Navigation</h6>
                        <Row className="mb-3">
                            <Form.Group as={Col} md={4} controlId="tobeaddedinmenu">
                                <Form.Label>Add to Menu (0/1):</Form.Label>
                                <Form.Control type="number" value={tobeaddedinmenu} onChange={(e) => setToBeAddedInMenu(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={4} controlId="iscommon">
                                <Form.Label>Is Common (0/1):</Form.Label>
                                <Form.Control type="number" value={iscommon} onChange={(e) => setIsCommon(e.target.value)} />
                            </Form.Group>
                            <Form.Group as={Col} md={4} controlId="issecure">
                                <Form.Label>Is Secure (0/1):</Form.Label>
                                <Form.Control type="number" value={issecure} onChange={(e) => setIsSecure(e.target.value)} />
                            </Form.Group>
                        </Row>

                        <h6 className="text-primary border-bottom pb-2 mb-3 mt-4">Layout Settings</h6>
                        <Row className="mb-3 text-center">
                            <Form.Group as={Col}><Form.Label>Header</Form.Label><Form.Control type="number" value={hasheader} onChange={(e) => setHasHeader(e.target.value)} /></Form.Group>
                            <Form.Group as={Col}><Form.Label>Menubar</Form.Label><Form.Control type="number" value={hasmenubar} onChange={(e) => setHasMenubar(e.target.value)} /></Form.Group>
                            <Form.Group as={Col}><Form.Label>L-Sidebar</Form.Label><Form.Control type="number" value={hasleftsidebar} onChange={(e) => setHasLeftSidebar(e.target.value)} /></Form.Group>
                            <Form.Group as={Col}><Form.Label>R-Sidebar</Form.Label><Form.Control type="number" value={hasrightsidebar} onChange={(e) => setHasRightSidebar(e.target.value)} /></Form.Group>
                            <Form.Group as={Col}><Form.Label>Footer</Form.Label><Form.Control type="number" value={hasfooter} onChange={(e) => setHasFooter(e.target.value)} /></Form.Group>
                        </Row>

                        <Form.Group className="mb-4" controlId="pagecontent">
                            <Form.Label className="fw-bold">Page Content:</Form.Label>
                            <JoditEditor
                                ref={editor}
                                value={pagecontent}
                                onBlur={(newContent) => setPageContent(newContent)}
                            />
                        </Form.Group>

                        <div className="form-actions mt-4">
                            <button type="submit" className="btn-gradient-primary">
                                Update Page
                            </button>
                            <Link to="/pages" className="btn-back-link ms-3 text-decoration-none text-muted">
                                ← Back to List
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} centered>
                <Modal.Header closeButton><Modal.Title>Confirm Update</Modal.Title></Modal.Header>
                <Modal.Body>Are you sure you want to save the changes to this page?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUpdateModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleUpdate}>Update</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default UpdatePage;
